module.exports = __webpack_public_path__ + "media/images/liz-4353abfdd4b98c6f7d83689d9b3868d8.jpg";